import type { NDateLocale } from './enUS'
import { ta } from 'date-fns/locale'

const dateTaIN: NDateLocale = {
  name: 'ta-IN',
  locale: ta
}

export default dateTaIN
